var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._l((_vm.words), function(word) {
    return _c('span', {
      staticClass: "word nowrap"
    }, _vm._l((word), function(letter, key) {
      return (letter !== ' ') ? _c('span', {
        class: ['letter', {
          'letter_animated': _vm.isActive
        }, {
          'letter_wider': letter == 'f'
        }]
      }, [_c('span', {
        style: (("animation-delay: " + ((key * 70)/1000) + "s"))
      }, [_vm._v(_vm._s(letter))])]) : _vm._e()
    }))
  }), _vm._v(" "), (_vm.isActive) ? [_c('ins', {
    staticClass: "decor-line decor-line_hor1"
  }), _vm._v(" "), _c('ins', {
    staticClass: "decor-line decor-line_hor2"
  }), _vm._v(" "), _c('ins', {
    staticClass: "decor-line decor-line_vert1"
  }), _vm._v(" "), (_vm.titleValue.length > 10) ? [_c('ins', {
    staticClass: "decor-line decor-line_hor3"
  }), _vm._v(" "), _c('ins', {
    staticClass: "decor-line decor-line_vert2"
  })] : _vm._e()] : _vm._e()], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fa7a5892","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageTitleContent.vue
// module id = 213
// module chunks = 0